import React from 'react';
import PropTypes from 'prop-types';
import DialogBox from '@components/DialogBox';
import { ModalContainer, ModalHeaderContainer } from '@containers/layout';
import { Box, Text, Button } from '@components/common';
import { HeadLine } from '@components/Typography';

function SpruceBookingModal(props) {
  const { show, dismiss, link } = props;

  const directToCTA = () => {
    window.open(link, '_blank');
  };

  return (
    <DialogBox show={show} onClickOutside={dismiss}>
      <ModalContainer>
        <ModalHeaderContainer>
          <HeadLine textAlign="center">The Minte has joined Spruce!</HeadLine>
        </ModalHeaderContainer>

        <Box display="flex" flexDirection="column">
          <Text fontSize={2}>
            To schedule a new service or manage your bookings, please use the
            Spruce app or website.
          </Text>
          <br />
          <Text fontSize={2}>
            Moving forward, you will no longer be able to schedule services
            through The Minte.
          </Text>
          <br />
          <Text fontSize={2}>
            Download the Spruce app using the button below.
          </Text>
          <br />
          <Button flex={1} mb={4} type="button" onClick={directToCTA}>
            Get Spruce
          </Button>

          <Text fontSize={2}>
            Questions?{' '}
            <a href="https://getspruce.com/spruce-acquires-the-minte/">
              Check out our FAQs
            </a>{' '}
            or contact us for support at{' '}
            <a href="mailto:service@getspruce.com">service@getspruce.com</a> or
            <a href="tel:+13127204834">(312) 720-4834</a>.
          </Text>
          <br />
        </Box>
      </ModalContainer>
    </DialogBox>
  );
}

SpruceBookingModal.propTypes = {
  link: PropTypes.string,
  show: PropTypes.bool,
  dismiss: PropTypes.func
};

export default SpruceBookingModal;
